/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateBankRequestViewModel } from "../types/CreateBankRequestViewModel.ts";
import { bankCreditCardItemViewModelSchema } from "./bankCreditCardItemViewModelSchema.ts";

export const createBankRequestViewModelSchema = z.object({
  code: z.number().int().nullish(),
  agency: z.string().nullish(),
  accountNumber: z.string().nullish(),
  station: z.string().nullish(),
  quantityDaysDown: z.number().int().nullish(),
  name: z.string().nullish(),
  image: z.string().nullish(),
  merchant: z.string().nullish(),
  bankPortfolio: z.string().nullish(),
  currency: z.string().nullish(),
  placePayment: z.string().nullish(),
  address: z.string().nullish(),
  phone: z.string().nullish(),
  cnpj: z.string().nullish(),
  instructionDefault1: z.string().nullish(),
  instructionDefault2: z.string().nullish(),
  instructionDefault3: z.string().nullish(),
  serialNextValue: z.number().int().nullish(),
  emailContactFealq: z.string().nullish(),
  companyId: z.number().int().nullish(),
  institution: z.number().int().nullish(),
  billetIntegration: z.optional(z.boolean()),
  billetIntegrationPecegePay: z.optional(z.boolean()),
  integrationPaymentsFealq: z.optional(z.boolean()),
  integrationPaymentsVanzolini: z.optional(z.boolean()),
  integrationPaymentsFusp: z.optional(z.boolean()),
  integrationPaymentsFDTE: z.optional(z.boolean()),
  billetIntegrationRaOnly: z.optional(z.boolean()),
  billetIntegrationUrl: z.string().nullish(),
  billetIntegrationRoot: z.string().nullish(),
  billetIntegrationPort: z.optional(z.number().int()),
  billetIntegrationUsername: z.string().nullish(),
  billetIntegrationPassword: z.string().nullish(),
  aprovaFacilApcUrl: z.string().nullish(),
  aprovaFacilStacUrl: z.string().nullish(),
  mundiPaggMerchantKey: z.string().nullish(),
  serialAdjustment: z.optional(z.boolean()),
  serialAdjustmentPrefix: z.optional(z.number().int()),
  serialAdjustmentPrefixCondition: z.optional(z.number().int()),
  allowAprovaFacil: z.optional(z.boolean()),
  allowMundiPagg: z.optional(z.boolean()),
  allowCreditCardPecegePay: z.optional(z.boolean()),
  billetRegistrationFee: z.number().nullish(),
  billetSettlementFee: z.number().nullish(),
  billetCancellationFee: z.number().nullish(),
  creditCardSuccessTransactionFee: z.number().nullish(),
  creditCardTransferFee: z.number().nullish(),
  walletId: z.string().nullish(),
  walletIdCreditCard: z.string().nullish(),
  thumbPrintSsl: z.string().nullish(),
  googlePayGatewayMerchantId: z.string().nullish(),
  hybridBillet: z.optional(z.boolean()),
  enablePecegePay: z.optional(z.boolean()),
  creditCards: z
    .array(z.lazy(() => bankCreditCardItemViewModelSchema))
    .nullish(),
}) as unknown as ToZod<CreateBankRequestViewModel>;
